import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
  return array.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {});
}

const initialState = {
  isLoading: false,
  empaqueUserCart: [],
  total: 0
};

const slice = createSlice({
  name: 'dagpacketEmpaqueUser',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    addEmpaqueUserCart(state, action) {
      const obj = action.payload;

      const filtered = state.empaqueUserCart.filter((item) => item.id !== obj.id);
      state.empaqueUserCart = [...filtered, obj];
    },

    removeEmpaqueUser(state, action) {
      const id = action.payload;

      const filtered = state.empaqueUserCart.filter((item) => item.id !== id);
      state.empaqueUserCart = filtered;
    },

    calcTotal(state, action) {
      const obj = action.payload;
      // const { selected_price } = obj;
      const cartArr = state.empaqueUserCart;

      let total = 0;

      // eslint-disable-next-line array-callback-return
      cartArr.map((item) => {
        total += item.price_total;
      });

      state.total = total;
    },

    resetEmpaqueUserSlice(state) {
      state.empaqueUserCart = [];
      state.total = 0;
    }
  }
});

// Reducer
export default slice.reducer;

// Actions
export const { addEmpaqueUserCart, removeEmpaqueUser, calcTotal, setEmpaqTipoEnvio, resetEmpaqueUserSlice } =
  slice.actions;

// ----------------------------------------------------------------------

export function addEmpaqueUserCartAction(obj) {
  return (dispatch) => {
    dispatch(addEmpaqueUserCart(obj));
    dispatch(calcTotal(obj));
    // dispatch(setEmpaqTipoEnvio());
  };
}

export function removeEmpaqueUserAction(obj) {
  return (dispatch) => {
    dispatch(removeEmpaqueUser(obj.id));
    dispatch(calcTotal(obj));
    // dispatch(setEmpaqTipoEnvio());
  };
}

// ----------------------------------------------------------------------
